import { TextField, TextFieldProps } from '@material-ui/core'
import React from 'react'
import { NumberFormatProps } from 'react-number-format'
import { NumberFormatCustom } from './NumberFormatCustom'

import './NumberInput.scss'

export type NumberInputProps = TextFieldProps & {
  textAlign?: 'left' | 'center' | 'right'
  required?: boolean
  suffix?: string
  preffix?: string
  decimalScale?: number
  disableUnit?: boolean
}

function NumberInput(props: NumberInputProps) {
  return (
    <TextField
      {...props}
      className="number-input"
      InputProps={{
        ...props.InputProps,
        inputComponent: NumberFormatCustom as never,
        inputProps: {
          fixedDecimalScale: false,
          style: { textAlign: props.textAlign || 'right' },
          decimalScale: props.decimalScale ?? 2,
          autoFocus: props.autoFocus,
          autoComplete: 'off',
          required: props.required,
          suffix: props.suffix || '',
          preffix: props.preffix || undefined,
        } as NumberFormatProps,
      }}
    />
  )
}

export { NumberInput }
